import { RouteObject } from "react-router-dom";
import { PolicyComponent } from "@components/policy/policy.component";
import { LoadPolicy } from "@components/policy/list/load-policy";

export const PolicyRouting = ({ path }: { path: string }): RouteObject[] => {
  const routerObject: RouteObject[] = [
    {
      path: "/",
      element: <PolicyComponent />,
      children: [
        {
          path: "poot",
          element: <LoadPolicy name={"poot"} />,
        },
        {
          path: "fomt",
          element: <LoadPolicy name={"fomt"} />,
        },
        {
          path: "dor",
          element: <LoadPolicy name={"dor"} />,
        },
        {
          path: "pocket-guide",
          element: <LoadPolicy name={"pocket"} />,
        },
        {
          path: "stardew",
          element: <LoadPolicy name={"stardew"} />,
        },
        {
          path: "pocket-guide-mh",
          element: <LoadPolicy name={"mh"} />,
        },
        {
          path: "pocket-remits",
          element: <LoadPolicy name={"remits"} />,
        },
        {
          path: "pocket-sports",
          element: <LoadPolicy name={"playab"} />,
        },
      ],
    },
  ];
  return routerObject.map((item) => {
    return {
      ...item,
      path: path + item.path,
    };
  }) as RouteObject[];
};
